<template>
    <div class="preview-container">
        <embed v-if="fileUrl" :src="fileUrl" class="preview-embed" />
    </div>
</template>

<script>
    import { fetchPrivateBlob } from 'services/PrivateFileService'

    export default {
        data() {
            return {
                fileUrl: null,
            }
        },

        methods: {
            getFile() {
                const url = this.$route.query.url
                fetchPrivateBlob(url)
                    .then((blob) => {
                        this.fileUrl = window.URL.createObjectURL(blob)
                    })
                    .catch(() => {
                        this.fileUrl = null
                    })
            },
        },

        mounted() {
            this.getFile()
        },
    }
</script>

<style>
    .preview-container {
        width: 100vw;
        height: 100vh;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }

    .preview-embed {
        width: 100%;
        height: 100%;
        border: none;
    }
</style>
